import React from "react";
import "./support-form.scss";
import { useDropzone } from "react-dropzone";

const SupportForm = () => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/*": [],
      "application/pdf": [],
    },
    maxFiles: 5,
    onDrop: (acceptedFiles) => {
      console.log("Dropped files:", acceptedFiles);
    },
  });

  return (
    <form className="support-form">
      <h5 className="form-title">Support</h5>

      <div className="row">
        <div className="col-lg-6 pe-md-2">
          <div className="input-wrap">
            <label htmlFor="">Full Name</label>
            <input type="text" placeholder="Write Full Name here..." />
          </div>
        </div>
        <div className="col-lg-6 ps-md-1">
          <div className="input-wrap">
            <label htmlFor="">Email</label>
            <input type="text" placeholder="Write Email here..." />
          </div>
        </div>
        <div className="col-lg-6 pe-md-2">
          <div className="input-wrap">
            <label htmlFor="">Phone Number</label>
            <input type="text" placeholder="Write Phone number here..." />
          </div>
        </div>
        <div className="col-lg-6 ps-md-1">
          <div className="input-wrap">
            <label htmlFor="">Order Number (Teleport Now's)</label>
            <input type="text" placeholder="Write Order Number Here..." />
          </div>
        </div>
        <div className="col-12">
          <div className="input-wrap">
            <label htmlFor=""> Preferred Contact Method</label>
            <div className="checks-wrap">
              <label className="custom-radio">
                <input
                  type="radio"
                  id="email"
                  name="contact_method"
                  value="email"
                  defaultChecked
                />
                <span className="radio-mark"></span>
                Email
              </label>

              <label className="custom-radio">
                <input
                  type="radio"
                  id="phone"
                  name="contact_method"
                  value="phone"
                />
                <span className="radio-mark"></span>
                Phone Call
              </label>
            </div>
          </div>

          <div
            {...getRootProps()}
            className={`custom-dropzone ${isDragActive ? "active" : ""}`}
          >
            <input {...getInputProps()} />
            <div className="upload-icon">
              <img src="/images/icons/upload-icon.svg" alt="Upload" />
            </div>
            <p className="upload-text">
              Click to browse or
              <br /> drag and drop your files
            </p>
          </div>
        </div>
        <div className="col-12">
          <div className="input-wrap">
            <label htmlFor=""> Comment</label>
            <textarea placeholder="Please describe the problem you’re facing with your ticket or journey."></textarea>
          </div>
        </div>
      </div>

      <button className="submit-btn">Submit</button>
    </form>
  );
};

export default SupportForm;
